import React from "react";
import { Dimmer, Loader } from "semantic-ui-react";

const PageLoader = ({ inverted = false, content = "Chargement..." }) => (
  <Dimmer active inverted={!inverted} style={{ background: "transparent" }}>
    <Loader inverted={inverted} content={content} />
  </Dimmer>
);

export default PageLoader;
